export default __webpack_public_path__ + "static/media/bg.defd0e26.svg";